import React from 'react';

export default function Statement2(){

    return(
        <div className='statement' id='workpage'>
           <h1>Applications that range from Full Stack to Networking</h1>
        </div>
    );
}